import { styled } from '@mui/system';
import { Link as RouteLink } from 'react-router-dom';
import { SIDE_NAV_WIDTH } from 'src/constants';

export const SidebarWrapper = styled('nav')`
  position: fixed;
  top: 0;
  left: 0;
  width: ${SIDE_NAV_WIDTH}px;
  height: 100vh;
  background: rgba(249, 249, 252, 1);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-items: center;
  padding: 25px;
  overflow-y: auto;
  z-index: 999;

  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const LogoLink = styled(RouteLink)(
  ({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    text-decoration: none;
    margin-bottom: 24px;
    background-color: ${theme.palette.primary.main};
    border-radius: 8px;

    svg {
      width: 36px;
      height: 32px;
      path {
        fill: ${theme.palette.common.white};
      }
    }
  `,
);

export const LogoWrapper = styled('div')(
  ({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    text-decoration: none;
    margin-bottom: 24px;
    background-color: ${theme.palette.primary.main};
    border-radius: 8px;

    svg {
      width: 36px;
      height: 32px;
      path {
        fill: ${theme.palette.common.white};
      }
    }
  `,
);

export const MenuList = styled('ul')`
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 8px;
  align-items: center;
`;

export const MenuItem = styled(RouteLink)(
  ({ $isSelected, theme }: any) => `
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px;
    border-radius: 8px;
    text-decoration: none;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    justify-content: center;

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${theme.palette.text.primary};
      transition: color 0.2s ease-in-out;

      svg {
        width: 24px;
        height: 24px;
        transition: fill 0.2s ease-in-out;
        path {
          fill: inherit;
        }
      }
    }

    .label {
      font-size: 14px;
      font-weight: 500;
      color: ${
        $isSelected ? theme.palette.primary.main : theme.palette.text.secondary
      };
      transition: color 0.2s ease-in-out;
      white-space: nowrap;
    }

    background: ${
      $isSelected ? `${theme.palette.primary.main}14` : 'transparent'
    };

    &:hover {
      background: ${theme.palette.action.hover};

      .icon svg,
      .icon svg path {
        fill: ${theme.palette.primary.main};
      }

      .label {
        color: ${theme.palette.primary.main};
      }
    }
  `,
);
